









import { defineComponent, ref } from "@vue/composition-api";
import { InputUserReferringSearch, UserReferring } from "@scrile/api-provider/dist/api/UserReferringProvider";
import useAuthUser from "@/hooks/useAuthUser";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";
import ReferralsView from "./components/ReferralsView.vue";

export default defineComponent({
  name: "PageReferrals",
  components: { ReferralsView },
  setup() {
    const { authUserStrict } = useAuthUser();
    const loading = ref(false);
    const userReferrerPercent = ref(0);
    const { enableScroll, getFirstPage, getNextPage, items: userReferrings } = usePager<
      UserReferring,
      InputUserReferringSearch
    >(page =>
      providers.UserReferringProvider.find({
        data: { referrerId: authUserStrict.value.id, sort: "UPDATE_TIME,DESC", page },
      })
    );

    const getReferrerPercent = async () => {
      const response = await providers.UserReferrerPercentProvider.find({ referrerId: authUserStrict.value.id });
      userReferrerPercent.value = response.percent;
    };

    const getData = async () => {
      try {
        loading.value = true;
        await Promise.all([getFirstPage(), getReferrerPercent()]);
      } finally {
        loading.value = false;
      }
    };

    getData();

    return {
      loading,
      enableScroll,
      userReferrings,
      userReferrerPercent,
      getNextPage,
    };
  },
});
